"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AirwebTicketLegacyDocumentService = void 0;
class AirwebTicketLegacyDocumentService {
    constructor(client) {
        this.client = client;
    }
    async getDocuments(networkId, options = {}) {
        const response = await this.client.http.get('Document/getDocuments.json', Object.assign(Object.assign({}, options), { params: { networkId } }));
        return response.data.documents || [];
    }
    async createDocumentsSubmission(userToken, itemId, documentIds, options = {}) {
        const response = await this.client.http.post('Document/createDocumentsSubmission.json', { userToken, item_id: itemId, document_ids: documentIds, userId: options.userId }, options);
        return response.data.id || null;
    }
    async updateDocumentsSubmission(userToken, submissionId, documentIds, options = {}) {
        const response = await this.client.http.post('Document/updateDocumentsSubmission.json', {
            userToken,
            submission_id: submissionId,
            document_ids: documentIds,
            userId: options.userId,
        }, options);
        return response.data.id || null;
    }
    async getUserDocuments(userToken, options = {}) {
        const response = await this.client.http.get('Document/getUserDocuments.json', Object.assign(Object.assign({}, options), { params: Object.assign({ userToken, userId: options.userId }, (options.params || {})) }));
        return response.data;
    }
    async getUserDocumentSubmission(userToken, options = {}) {
        const response = await this.client.http.get('Document/getUserDocumentSubmissions.json', Object.assign(Object.assign({}, options), { params: Object.assign({ userToken, userId: options.userId }, (options.params || {})) }));
        return response.data.submissions;
    }
    uploadDocument(userToken, userId, documentTypeId, document, options = {}) {
        return this.client.media.uploadDocument(userToken, userId, documentTypeId, document, options);
    }
    async getFileDownloadUrl(userToken, documentId) {
        const { data } = await this.client.http.get('Document/fileDownloadUrl', {
            params: {
                userToken,
                documentId,
            },
        });
        return data;
    }
}
exports.AirwebTicketLegacyDocumentService = AirwebTicketLegacyDocumentService;
//# sourceMappingURL=document.service.js.map